module.exports = __webpack_public_path__ + "ay.no2.b0c3fe0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ay.no2.jpg
// module id = Gcm4
// module chunks = 0